module.exports = __webpack_public_path__ + "img/case51.1cc6b371.png";